/**
 * Mobile Menu Toggle
 * Minimal and lightweight menu overlay functionality
 *
 * @package EVT Restaurant Builder
 * @since 1.0.0
 */

export function initMobileMenu() {
    const toggle = document.querySelector('[data-menu-toggle]');
    const overlay = document.querySelector('[data-mobile-menu]');
    const closeBtn = overlay?.querySelector('.mobile-menu-close');

    if (!toggle || !overlay) return;

    const openMenu = () => {
        overlay.classList.add('is-active');
        document.body.classList.add('menu-open');
        toggle.querySelector('.menu-toggle')?.setAttribute('aria-expanded', 'true');
    };

    const closeMenu = () => {
        overlay.classList.remove('is-active');
        document.body.classList.remove('menu-open');
        toggle.querySelector('.menu-toggle')?.setAttribute('aria-expanded', 'false');
    };

    // Open menu on toggle click
    toggle.addEventListener('click', openMenu);

    // Close menu on close button click
    closeBtn?.addEventListener('click', closeMenu);

    // Close menu on overlay background click
    overlay.addEventListener('click', (e) => {
        if (e.target === overlay) closeMenu();
    });

    // Close menu on ESC key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && overlay.classList.contains('is-active')) {
            closeMenu();
        }
    });
}
